import Request from './../request';
import { IVoucherResourceShort } from '../../props/vouchers';

// import interfaces

const VoucherService = {
  retrieve: async (): Promise<IVoucherResourceShort[]> => {
    try {
      const results = await Request.get(`/api/vouchers`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IVoucherResourceShort[]> => {
    try {
      const results = await Request.post(`/api/vouchers`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IVoucherResourceShort[]> => {
    try {
      const results = await Request.post(`/api/vouchers/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IVoucherResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/vouchers/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
};

export default VoucherService;
